import { useEffect, useState } from 'react';

export type Route =
  | { name: 'home' }
  | { name: 'lessons' }
  | { name: 'texts' }
  | { name: 'lesson'; lessonId: string; mode?: string }
  | { name: 'text'; textId: string }
  | { name: 'custom' }
  | { name: 'progress' }
  | { name: 'settings' }
  | { name: 'guide' }
  | { name: 'calibrate' };

export function parseHash(hash: string): Route {
  const clean = hash.replace(/^#\/?/, '');
  const [head, param, sub] = clean.split('/');
  switch (head) {
    case 'lekcie':
      return { name: 'lessons' };
    case 'texty':
      return { name: 'texts' };
    case 'cvicenie':
      return param ? { name: 'lesson', lessonId: param, mode: sub } : { name: 'lessons' };
    case 'text':
      return param ? { name: 'text', textId: param } : { name: 'texts' };
    case 'vlastny':
      return { name: 'custom' };
    case 'pokrok':
      return { name: 'progress' };
    case 'nastavenia':
      return { name: 'settings' };
    case 'sprievodca':
      return { name: 'guide' };
    case 'kalibracia':
      return { name: 'calibrate' };
    default:
      return { name: 'home' };
  }
}

export function navigate(hash: string) {
  window.location.hash = hash;
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseHash(window.location.hash));
  useEffect(() => {
    const onHashChange = () => {
      setRoute(parseHash(window.location.hash));
      window.scrollTo({ top: 0 });
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return route;
}
